import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Inject, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { AlertService } from 'src/app/services/alert.service';
import { BookService } from 'src/app/services/book.service';
import { Company, ConfigService } from 'src/app/services/config.service';
import { ACCESS_ERROR_CODE, UserAccessService } from 'src/app/services/user-access.service';
import { environment } from './../../../environments/environment';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { GlobalVariables } from 'src/app/data/global-variables';
import { LoginService } from 'src/app/services/login.service';
import { CookieService } from 'ngx-cookie-service';
import { Permissions, TokenPermissions } from 'src/app/data/permissions';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
  selector: 'app-check-access',
  // templateUrl: 'assets/htmlTemplates/checkAccess.html',
  templateUrl: './check-access.component.html',
  styleUrls: ['./check-access.component.css']
})
export class CheckAccessComponent implements OnInit {

  @Input() token!: string;
  @Output() tokenChange = new EventEmitter<string>();
  @Input() accessToken!: string;
  @Input() externalToken!: string;
  userName: string | null = null;
  password: string | null = null;

  html_desktop: SafeHtml | undefined;
  html_mobile: SafeHtml | undefined;

  codeType: 'date' | 'text' | 'dni' | null = null;

  window = window;

  @Output() grantAccess = new EventEmitter<void>();

  get company() {
    switch (this.configService.company) {
      case Company.DEBRAIN:
        return 'DeBrain'
      case Company.M3M:
        return 'M3M';
      default:
        return '';
    }
  }

  get accessWithLogin() {
    return this.configService?.config?.access_with_login;
  }

  get shareWithPrescriptor() {
    return this.configService?.config?.share_with_prescriptor;
  }

  options: {
    headerPng: string,
    welcomeText: string,
    paragraph1: string,
    paragraph2: string,
  } | null = null;

  constructor(
    private alertService: AlertService,
    private bookService: BookService,
    private userAccess: UserAccessService,
    private configService: ConfigService,
    private sanitizer: DomSanitizer,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    public globalVariables: GlobalVariables,
    private http: HttpClient,
    private cookieService: CookieService,
    private loginService: LoginService,
    private permissionService: PermissionService
  ) {
    this.http.get<string>('assets/welcomePageResources/login_desktop.html', { responseType: 'string' as 'json' }).subscribe(
      next => {
        this.html_desktop = this.sanitizer.bypassSecurityTrustHtml(next);
      },
      error => {
        console.error('ERROR', error);
      });

    this.http.get<string>('assets/welcomePageResources/login_mobile.html', { responseType: 'string' as 'json' }).subscribe(
      next => {
        this.html_mobile = this.sanitizer.bypassSecurityTrustHtml(next);
      },
      error => {
        console.error('ERROR', error);
      });

    this.http.get<any>('assets/welcomePageResources/welcomePageOptions.json', { responseType: 'json' }).subscribe(data => {
      this.options = data;
    });

    this.configService.getConfig().then(c => {
      if (c.access_type?.toLowerCase() == 'date') {
        this.codeType = 'date';
      } else if (c.access_type?.toLowerCase() == 'dni') {
        this.codeType = 'dni';
      } else if (c.access_type?.toLowerCase() == 'text') {
        this.codeType = 'text';
      } else {
        this.codeType = 'text'
      }
    })

    // SCRIPTS QUE SON LLAMADOS DESDE EL HTML
    let script = this._renderer2.createElement('script');
    script.type = `text/javascript`;
    script.text = `
          function sendLogin() {
            let code = document.getElementById('code').value;
            let disclaimer = document.getElementById('disclaimer');
            if(disclaimer==null) {
              const event = new CustomEvent("login", { detail: code });
              document.dispatchEvent(event);
            } else {
              if(disclaimer.checked) {
                const event = new CustomEvent("login", { detail: code });
                document.dispatchEvent(event);
              } else {
                if(
                  document.getElementById('code').value==null || document.getElementById('code').value.trim()==''
                ) {
                  alert('Introduzca todos los datos solicitados para acceder a sus resultados');
                } else {
                  alert('Debe aceptar los términos y condiciones para continuar');
                }
              }
            }
          }
        `;

    this._renderer2.appendChild(this._document.body, script);

    document.addEventListener("login", (evt: Event) => {
      this.checkAccess((evt as CustomEvent).detail);
    })
  }

  ngOnInit(): void {
    // ✅ NUEVO: Verificar si hay sesión de paciente activa
    const patientSession = this.cookieService.get('patient_session');
    
    if (patientSession != null && patientSession != '' && this.token != null) {
      // Validar que el token pertenece al mismo paciente
      this.bookService.getPatientIdByToken(this.token).then(patientId => {
        if (patientId != null && patientId !== '' && patientId.toString() === patientSession) {
          // ✅ Mismo paciente, conceder acceso automático
          const storedAuthToken = localStorage.getItem('DBAuthTkn');
          if (storedAuthToken != null) {
            // ✅ Eliminar cookie después de validar (se creará nueva al abrir otro book)
            this.cookieService.delete('patient_session');
            this.bookService.getDefaultPermissions().then(permissions => {
              this.permissionService.permissions = new Set(Permissions.sanitizeAll(permissions));;
              this.grantAccess.emit();
              return; 
            });           
          }
        } else {
          // Si no coincide, eliminar cookie y continuar con flujo normal
          this.cookieService.delete('patient_session');
          this.continueNormalFlow();
        }
      });
    } else {
      this.continueNormalFlow();
    }
  }


  private continueNormalFlow() {
    if (environment.demo) {
      if (environment.demoLaptop) {
        this.grantAccess.emit();
      } else {
        if (this.accessToken != null) {
          this.userAccess.grantAccess(this.accessToken, this.token)
            .then(res => this.grantAccess.emit())
            .catch(err => this.loginService.showError(err))
        }
      }
    } else {
      // Se mira si hay token de portal en la cookie. Si hay token se le pregunta al portal los datos del token y de la sesión
      const portalToken = this.cookieService.get('portal_token');
      if (portalToken != null && portalToken != '') {
        this.cookieService.delete('portal_token');
        this.userAccess.grantAccessFromCookies(portalToken)
          .then(res => this.grantAccess.emit())
          .catch(err => this.loginService.showError(err))
      }
      if (this.accessToken == null) {
        this.accessToken = this.cookieService.get('code');
        this.cookieService.delete('code');
      }
      if (this.accessToken != null && this.accessToken != '') {
        this.userAccess.grantAccess(this.accessToken, this.token)
          .then(res =>{
              this.bookService.getPatientIdByToken(this.token).then(patientId => {
                if (patientId != null && patientId !== '') {
                  // Cookie válida por 2 horas
                  this.cookieService.set('patient_session', patientId.toString(), 
                    undefined, '/', undefined, false, 'Strict');
                }
              this.grantAccess.emit();
              });
          } )
          .catch(err => this.loginService.showError(err))
      }
      if (this.externalToken != null) {
        console.log('this.externalToken', this.externalToken);
        this.userAccess.grantAccessExternalToken(this.externalToken)
          .then(res => {
            this.token = res;
            this.tokenChange.emit(res);
            this.grantAccess.emit()
          })
          .catch(err => this.loginService.showError(err))
      }
    }
  }

  checkAccess(code: string) {
    if (code == null || code.trim() == '') {
      this.alertService.alert("Por favor, introduzca el código de acceso");
      return;
    }
    if (this.codeType == 'date') {
      const parsed = this.loginService.parseDate(code);
      if (parsed == null) return;
      code = parsed
    }
    if (this.codeType == 'dni') {
      if (code.length < 9) {
        this.alertService.alert("El DNI debe tener 9 caracteres");
        return;
      }
      const dniRegex = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKETtrwagmyfpdxbnjzsqvhlcket]|[XYZxyz][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKETtrwagmyfpdxbnjzsqvhlcket]$/;
      if (!dniRegex.test(code)) {
        this.alertService.alert("El DNI no es válido. Se debe escribir sin puntos ni guiones, por ejemplo 12345678A o X1234567A");
        return;
      }
    }
    this.userAccess.grantAccess(code, this.token)
      .then(res => this.grantAccess.emit())
      .catch(err => this.loginService.showError(err))
  }

  checkAccessWithUser() {
    this.userAccess.grantAccessWithUser(this.token, this.userName!, this.password!)
      .then(res => this.grantAccess.emit())
      .catch(err => this.loginService.showError(err))
  }

  sendMail(mail: string) {
    if (mail == null || mail.trim() == '') {
      this.alertService.alert('Por favor, introduzca un correo electrónico');
    } else {
      if (!environment.demo) {
        if(this.configService._systemConfig?.prpSlave){
          this.bookService.sendBookMailByPRP(mail, this.token).subscribe(res => {
            if(res){
              this.alertService.alert('Correo enviado');
            }else{
              this.alertService.alert('Ha ocurrido un error al enviar el correo');
            }
            
          });
        }else{
          this.bookService.sendNotifToMail(mail, this.token).subscribe(res => {
            this.alertService.alert('Correo enviado');
            // alert('Correo enviado')
          });
        }
        
      }
    }

    
  }

}
